module.exports = __webpack_public_path__ + "assets/selected-embed-tag.95f82c82.svg";